import isUndefined from 'lodash/isUndefined';

export default function buildIntegrationStatusDetails(integrationRow) {
  const isDeployed = !isUndefined(integrationRow.deployedRevision);
  const isEnabled = !integrationRow.pipelineIntegration.disabled;
  const isStagedForDelete = integrationRow.stagedForDelete;

  return {
    isDeployed,
    isEnabled,
    isStagedForDelete,
  };
}
